module.exports = __webpack_public_path__ + "static/media/csv_download.c8cc2f6c.svg";